import { render, staticRenderFns } from "./Somos1DataEntry.vue?vue&type=template&id=1ef192b4&scoped=true"
import script from "./Somos1DataEntry.vue?vue&type=script&lang=js"
export * from "./Somos1DataEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef192b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef192b4')) {
      api.createRecord('1ef192b4', component.options)
    } else {
      api.reload('1ef192b4', component.options)
    }
    module.hot.accept("./Somos1DataEntry.vue?vue&type=template&id=1ef192b4&scoped=true", function () {
      api.rerender('1ef192b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/Somos1DataEntry.vue"
export default component.exports